import VectorLayer from 'ol/layer/vector';
import VectorSrc from 'ol/source/vector';

import Feature from 'ol/feature';
import Point from 'ol/geom/point';

import Style from 'ol/style/style';
import Fill from 'ol/style/fill';
import Stroke from 'ol/style/stroke';
import Circle from 'ol/style/circle';
import Text from 'ol/style/text';
import GeoJSON from 'ol/format/geojson';

import layerUtils from './layers';

/* -------------------------------------------------------------------------- */
/* -- CONSTANTS ------------------------------------------------------------- */

const PIN_LAYER_NAME = '_pinLayer_';
const PIN_FILL_COLOR = 'rgba(192, 128, 128, 0.5)';
const PIN_STROKE_COLOR = 'rgb(255, 34, 34)';
const PIN_RADIUS = 3;
const PIN_STROKE_WIDTH = 3;
const PIN_TEXT_FONT = "normal normal bolder 1em 'Ubuntu Mono', 'DejaVu Sans Mono', 'Liberation Mono', 'Arial', 'Courier New', 'Times New Roman', monospace";

const GEOJSON_LAYER_NAME = '_geoJson_';
const FEATURE_PROJECTION = 'EPSG:3857';

const pinSrc = new VectorSrc();
const geoJsonSrc = new VectorSrc();

const pinLayer = new VectorLayer({ source: pinSrc });

const hideAndSeekWithText = function(feature){
    if (window.GisMap.getView().getZoom() > 12){
        return feature.get("name");
    }
    return "";
};

const pointStyle = (feature) => {
    return new Style({
        image: new Circle({
            radius: 1,
            stroke: new Stroke({ color: "gray", width: 2 }),
        }),
        text: new Text({
            text: hideAndSeekWithText(feature),
            offsetY: 8,
            font: PIN_TEXT_FONT,
            fill: new Fill({ color : "black" }),
            scale: 1.2
        })
    });
};

const searchedPointStyle = (feature) => {
    return new Style({
        image: new Circle({
            radius: 3,
            stroke: new Stroke({ color: "violet", width: 2 })
        })
    });
};

const basicStyle = (feature) => {
    return new Style({
        stroke: new Stroke({ color: 'rgba(0, 132, 201, 0.4)', width: 2 }),
        fill: new Fill({ color: [255, 255, 255, 0.1] }),
        text: new Text({
            text: feature.get("name"),
            font: PIN_TEXT_FONT,
            fill: new Fill({ color: "black" }),
            scale: 1.4
        })
    });
};

const searchedStyle = (feature) => {
    return new Style({
        stroke: new Stroke({ color : "violet", width : 2 })
    });
};

const singlePointStyle = (feature) => {
    return new Style({
        image: new Circle({
            radius: 2,
            stroke: new Stroke({ color: 'rgba(0, 0, 0, 0.75)', width: 1.5 }),
            fill: new Fill({ color: 'rgba(0, 132, 201, 0.4)' }),
        }),
        text: new Text({
            text: feature.get("name"),
            offsetY: 8,
            font: PIN_TEXT_FONT,
            fill: new Fill({ color : "black" }),
            scale: 1.2
        })
    });
};

const singleFeatureStyle = (feature) => {
    return new Style({
        stroke: new Stroke({ color: "violet", width: 2 }),
        fill: new Fill({ color: [255, 255, 255, 0.1] }),
        text: new Text({
            text: feature.get("name"),
            font: PIN_TEXT_FONT,
            fill: new Fill({ color: "black" }),
            scale: 1.4
        })
    });
};

const geoJsonLayer = new VectorLayer({
    source: geoJsonSrc,
    format: new GeoJSON(),
    style: function(feature) {
        if (feature.getGeometry() instanceof Point) {
            return singlePointStyle(feature);
        }
        return singleFeatureStyle(feature);
    }
});

layerUtils.setLayerName(pinLayer, PIN_LAYER_NAME);
layerUtils.setLayerName(geoJsonLayer, GEOJSON_LAYER_NAME);

const addPin = (map, location) => {
    pinToMap(map, createPinFeature(location));
};

const addGeoJson = (map, geoJson, name) => {
    geoJsonToMap(map, geoJson, name);
};

const createPinFeature = location => {
    let feat = new Feature({
        geometry: new Point(location.coords),
        name: location.label
    });

    feat.setStyle(createPinStyle(location.coords, location.label));

    return feat;
};

function createPinStyle(coord, label) {
    return new Style({
        image: new Circle({
            center: coord,
            radius: PIN_RADIUS,
            fill: new Fill({
                color: PIN_FILL_COLOR,
            }),
            stroke: new Stroke({
                color: PIN_STROKE_COLOR,
                width: PIN_STROKE_WIDTH,
            }),
        })
    });
}

const pinToMap = (map, feature) => {
    let layer = layerUtils.getLayer(map, PIN_LAYER_NAME);

    if (!layer) {
        map.addLayer(pinLayer);
        layer = pinLayer;
    }

    layer.getSource().addFeature(feature);
};


const geoJsonToMap = (map, geoJson) => {
    let layer = layerUtils.getLayer(map, GEOJSON_LAYER_NAME);

    if (!layer) {
        map.addLayer(geoJsonLayer);
        layer = geoJsonLayer;
    }

    if (geoJson.features != null && geoJson.features.length > 0 && geoJson.features[0].geometry != null){
        let features = (new GeoJSON({ featureProjection: FEATURE_PROJECTION })).readFeatures(geoJson.features[0].geometry);

        features.forEach((f) => {
            f.set('name', geoJson.features[0].properties.name);
            layer.getSource().addFeature(f);
        });
    }

};

const clusteredStyle = (feature) => {
    let size = feature.get('features').length;
    let style;

    if (size > 1){
        style= new Style({
            image: new Circle({
                radius: 10,
                stroke: new Stroke({color: "blue"}),
                fill: new Fill({color: "white"})
            }),
            text: new Text({
                text: size.toString(),
                font: PIN_TEXT_FONT,
                fill: new Fill({ color : "black" }),
                scale: 1.2
            })
        });
    } else {
        var originalFeature = feature.get('features')[0];
        style = pointStyle(originalFeature);
    }

    return style;
}

export default {
    addPin,
    addGeoJson,
    basicStyle,
    pointStyle,
    searchedStyle,
    searchedPointStyle,
    clusteredStyle
};



// WEBPACK FOOTER //
// ./resources/assets/js/src/maps/utils.js